import { BASE_URL, SOMS_API_KEY, SUPPLIER_DESTINATION_MAPPING_ENDPOINT } from "services/CONSTANTS";
import { ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE, ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST, ADD_SUPPLIER_DESTINATION_MAPPING_RESET, ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS } from "./action-type"
import { Post } from "services/apiService";

export const addSupplierDestinationMappingAction = (payload) => {
    return (dispatch) => {
        dispatch(addSupplierDestinationMappingRequest());
        let apiUrl = `${BASE_URL}${SUPPLIER_DESTINATION_MAPPING_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload
        };
        
        Post(request)
            .then((response) => {
                if (response.status >= 200 && response.status <= 299) {
                    dispatch(addSupplierDestinationMappingSuccess(response));
                } else {
                    dispatch(addSupplierDestinationMappingFailure(response));
                }
            })
            .catch((err) => {
                dispatch(addSupplierDestinationMappingFailure(err));
            });
    }
}

const addSupplierDestinationMappingRequest = () => {
    return {
        type: ADD_SUPPLIER_DESTINATION_MAPPING_REQUEST
    }
}

const addSupplierDestinationMappingSuccess = (response) => {
    return {
        type: ADD_SUPPLIER_DESTINATION_MAPPING_SUCCESS,
        addSupplierDestinationMappingResponse: response
    }
}

const addSupplierDestinationMappingFailure = (error) => {
    return {
        type: ADD_SUPPLIER_DESTINATION_MAPPING_FAILURE,
        addSupplierDestinationMappingResponse: error
    }
}

export const addSupplierDestinationMappingReset = () => {
    return {
        type: ADD_SUPPLIER_DESTINATION_MAPPING_RESET
    }
}